/**
 * Site-wide config for marketing/public pages: the nav links and the footer's
 * link columns. Centralised here so each page doesn't have to duplicate it.
 *
 * Everything an author can change now lives in the site-settings singleton
 * (`DEFAULT_SITE_SETTINGS` in @diality/contracts) — the social profiles, the
 * postal address, the newsletter copy and both legal paragraphs used to be
 * hardcoded here as a second copy of the same strings.
 */
import type {
  MarketingFooterLinkGroup,
  MarketingNavLinkItem,
} from "@diality/ui";

/**
 * Where the Contact call-to-action points. The nav renders Contact as a CTA pill
 * rather than a plain link, so a CMS menu item pointing here becomes that pill
 * instead of a sixth link.
 */
export const CONTACT_HREF = "/contact";

/** The nav the site falls back to when the CMS menu can't be read. */
export const PRIMARY_LINKS: MarketingNavLinkItem[] = [
  { label: "Our Story", href: "/our-story" },
  { label: "Product", href: "/product" },
  { label: "Patients", href: "/patients" },
  { label: "News", href: "/news" },
  { label: "Careers", href: "/careers" },
];

export const FOOTER_LINK_GROUPS: MarketingFooterLinkGroup[] = [
  {
    heading: "Explore",
    links: [
      { label: "Product", href: "/product" },
      { label: "Patients & Education", href: "/patients" },
      { label: "News & Events", href: "/news" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "Our Story", href: "/our-story" },
      { label: "Careers", href: "/careers" },
      { label: "Reach Us", href: "/contact" },
    ],
  },
  {
    heading: "Legal",
    links: [
      // { label: "Privacy Policy", href: "#" },
      // { label: "Terms of Use", href: "#" },
      // { label: "Cookie Settings", href: "#" },
      { label: "Corporate Governance", href: "/corporate-governance" },
      { label: "California Proposition 65", href: "/california-prop-65" },
    ],
  },
];
